import React, { useEffect, useState } from "react";
import { Button, Snackbar } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import { useMainState } from "modules/app/contexts";
import { useHistory } from "react-router-dom";

function WhatsappAlert() {
  const [show, setShow] = useState(true);
  const history = useHistory();
  const { whatsappOn } = useMainState();

  useEffect(() => {
    if (
      history.location.pathname == "/app" ||
      history.location.pathname.includes("/app/chat")
    ) {
      setShow(true);
    }
  }, [history.location]);

  return (
    <Snackbar
      open={
        !whatsappOn && history.location.pathname != "/app/credentials" && show
      }
    >
      <Alert
        severity="warning"
        style={{ width: "50em" }}
        action={
          <Button color="inherit" size="small" onClick={() => setShow(false)}>
            FECHAR
          </Button>
        }
      >
        <div
          style={{ cursor: "pointer" }}
          onClick={() => history.push("/app/credentials")}
        >
          <AlertTitle>
            <strong>ATENÇÃO</strong>
          </AlertTitle>
          <p>
            Seu Whatsapp está desconectado! <strong>Clique aqui</strong> para
            reconectar
          </p>
        </div>
      </Alert>
    </Snackbar>
  );
}

export default WhatsappAlert;
